module.exports = __webpack_public_path__ + "img/img_error.af08f2ec.png";